import Vue from 'vue'
import Component from 'vue-class-component'
import PageState from '../../store/state'
import moduleStore from '../../store/videoEditor';
import { TabBarListTypeMap, TabTypeMap } from '../../utils/constant'
import { Prop, Watch } from 'vue-property-decorator'

@Component({
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class TabBar extends Vue {
  state = new PageState();
  created(moduleData:IinjectDatas) {
    this.state = <PageState>moduleData.state;
  }
  tabPrefix = this.$publicPath + 'images/video_editor/tabbar_'
  // 默认tab
  tabBarNameList = [{
    name: '封面',
    icon: 'cover',
    type: TabTypeMap.COVER
  }, {
    name: '字幕',
    icon: 'subtitles',
    type: TabTypeMap.SUBTITLES
  }, {
    name: '发音人',
    icon: 'speaker',
    type: TabTypeMap.SPEAKER
  }, {
    name: '音乐',
    icon: 'music',
    type: TabTypeMap.MUSIC
  }, {
    name: '文本',
    icon: 'text',
    type: TabTypeMap.TEXT
  }]
  // 文字模板 tab
  editTextTemplateList = [{
    name: '新增文本',
    icon: 'add-text',
    type: TabTypeMap.ADD_TEXT_CONTENT
  }, {
    name: '编辑文本',
    icon: 'add-text',
    type: TabTypeMap.EDIT_TEXT_CONTENT
  }, {
    name: '文字模板',
    icon: 'text-template',
    type: TabTypeMap.EDIT_TEXT_TEMPLATE
  }, , {
    name: '字体',
    icon: 'font',
    type: TabTypeMap.FONT
  }, {
    name: '样式',
    icon: 'style',
    type: TabTypeMap.STYLE
  }, {
    name: '删除',
    icon: 'delete',
    type: TabTypeMap.DELETE_TEXT_CONTENT
  }]
  // 编辑图片tab
  editImgBarNameList = [ {
    name: '编辑图片',
    icon: 'edit',
    type: TabTypeMap.EDITIMG
  }, {
    name: '设置封面',
    icon: 'set_cover',
    type: TabTypeMap.SETCOVER
  }]
  // 编辑配音tab
  editSpeakerBarNameList = [{
    name: '编辑配音',
    icon: 'edit',
    type: TabTypeMap.EDITSPEAKER
  }]
  // 编辑背景音tab
  editMusicList = [{
    name: '编辑背景音乐',
    icon: 'edit',
    type: TabTypeMap.MUSIC
  }, {
    name: '音量',
    icon: 'volume',
    type: TabTypeMap.VOLUME
  },{
    name: '删除',
    icon: 'delete',
    type: TabTypeMap.DELETEVOLUME
  }]
  // 编辑器字体
  editFontBarNamleList = [{
    name: '编辑',
    icon: 'edit',
    type: TabTypeMap.EDITFONT
  }, {
    name: '字体',
    icon: 'font',
    type: TabTypeMap.FONT
  }, {
    name: '样式',
    icon: 'style',
    type: TabTypeMap.STYLE
  }, {
    name: '文字发音',
    icon: 'wordpron',
    type: TabTypeMap.WORDPRON
  }, {
    name: '数字发音',
    icon: 'numpron',
    type: TabTypeMap.NUMPRON
  }]
  // tabBarListMap = {}
  currentTabBarTag = TabBarListTypeMap.DEFAULT
  params = null
  // 是否显示动画
  showAnim = false
  // tabbar标签列表Map
  get tabBarListMap() {
    const _tabBarListMap = {}
    const listName = [TabBarListTypeMap.DEFAULT, TabBarListTypeMap.TEXT_TEMPLATE, TabBarListTypeMap.IMG, TabBarListTypeMap.SPEAKER, TabBarListTypeMap.FONT,TabBarListTypeMap.BGMUSIC]
    listName.forEach((listName) => {
      let tabBarList = []
      this[listName].forEach((item, index) => {
        tabBarList.push({
          id: index,
          name: item.name,
          icon: this.tabPrefix + item.icon + '.png',
          type: item.type
        })
      })
      console.log('tabBarListMap', this.state.operatingTextContent.text)
      // 编辑文字模板的时候特殊处理
      if (listName === TabBarListTypeMap.TEXT_TEMPLATE && this.state.operatingTextIndex !== null && this.state.operatingTextContent.text) {
        tabBarList = tabBarList.filter(item => {
          return item.type === TabTypeMap.EDIT_TEXT_CONTENT || item.type === TabTypeMap.EDIT_TEXT_CONTENT_STYLE || item.type === TabTypeMap.EDIT_TEXT_TEMPLATE || item.type === TabTypeMap.DELETE_TEXT_CONTENT || item.type === TabTypeMap.FONT || item.type === TabTypeMap.STYLE
        })
      }
      if (listName === TabBarListTypeMap.TEXT_TEMPLATE && this.state.operatingTextIndex === null) {
        tabBarList = tabBarList.filter(item => {
          return item.type === TabTypeMap.ADD_TEXT_CONTENT || item.type === TabTypeMap.EDIT_TEXT_CONTENT_STYLE || item.type === TabTypeMap.EDIT_TEXT_TEMPLATE
        })
      }
      if (listName === TabBarListTypeMap.TEXT_TEMPLATE && this.state.operatingTextIndex !== null && !this.state.operatingTextContent.text) {
        tabBarList = tabBarList.filter(item => {
          return item.type === TabTypeMap.ADD_TEXT_CONTENT || item.type === TabTypeMap.EDIT_TEXT_CONTENT_STYLE || item.type === TabTypeMap.EDIT_TEXT_TEMPLATE
        })
      }
      // 当前作品属于解压的时候特殊处理
      if (listName === TabBarListTypeMap.FONT && this.state.workType === 'down_stress') {
        tabBarList = tabBarList.filter(item => {
          return item.type === TabTypeMap.EDITFONT || item.type === TabTypeMap.FONT || item.type === TabTypeMap.STYLE
        })
      }
      if (listName === TabBarListTypeMap.DEFAULT && this.state.isHideBgMusic) {
        tabBarList = tabBarList.filter(item => {
          return item.type === TabTypeMap.COVER || item.type === TabTypeMap.SUBTITLES || item.type === TabTypeMap.SPEAKER || item.type === TabTypeMap.TEXT
        })
      }
      _tabBarListMap[listName] = tabBarList
    })
    return _tabBarListMap
  }
  animTimer = null
  @Watch('currentTabBarTag')
  listenCurrentTabBarTag(val) {
    this.showAnim = true
    this.animTimer = setTimeout(() => {
      this.showAnim = false
      clearTimeout(this.animTimer)
      this.animTimer = null
    }, 500)
  }
  /**
   * 切换tab数据
   * @param type
   * @param params 
   */
  changeTabList(params) {
    this.params = params.param
    this.params.index = params.index
    this.params.rcttsWordList = params.rcttsWordList
    // if (params.type !== TabBarListTypeMap.BGMUSIC) {
      this.currentTabBarTag = params.type
    // }
  }
  /**
   * 切换tab
   * @param tabInfo
   */
  changeTab(tabInfo) {
    this.$emit('change-tab', tabInfo.type, this.params)
  }
  /**
   * 返回初始菜单
   */
  backTabBar() {
    this.currentTabBarTag = TabBarListTypeMap.DEFAULT
  }
}